{
  "dismiss": "Odbaci"
}